import { IIncidentActivity } from "../interfaces/incident/IIncident";

// Raw socket payloads are not consistently shaped, so field names vary
export type IRawActivityPayload = Partial<IIncidentActivity> & Record<string, any>;

// Some messages on the activity topic are only "something changed" signals
// ({ action }) without the activity itself, so the caller must re-fetch.
export const isActivityChangeSignal = (raw: IRawActivityPayload): boolean =>
  Boolean(raw?.action);

export const toIncidentActivity = (
  raw: IRawActivityPayload,
  fallbackUserName: string,
): IIncidentActivity =>
  ({
    ...raw,
    createdAt:
      raw.createdAt || raw.timestamp || raw.created_at || new Date().toISOString(),
    userFullName:
      raw.userFullName || raw.userName || raw.fullName || raw.name || fallbackUserName,
  }) as IIncidentActivity;

// The same activity can arrive twice (e.g. after a reconnect), so skip duplicates
export const prependActivity = (
  activities: IIncidentActivity[],
  activity: IIncidentActivity,
): IIncidentActivity[] =>
  activity.id && activities.some((a) => a.id === activity.id)
    ? activities
    : [activity, ...activities];

const activityTime = (activity: IIncidentActivity): number =>
  new Date(activity.createdAt).getTime() || 0;

// Backend returns activities unsorted; the timeline shows the newest on top
export const sortActivitiesNewestFirst = (
  activities: IIncidentActivity[],
): IIncidentActivity[] =>
  [...activities].sort((a, b) => activityTime(b) - activityTime(a) || b.id - a.id);
